import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Layers, FolderTree, FileEdit, Settings, Activity, LogOut } from "lucide-react";
import { useAuth, useTheme } from "@/context/AuthContext";
import { Logo, Loader, ThemeToggle } from "@/components/brand";

const LINKS = [["Overview", "/admin", LayoutDashboard, true], ["Companies", "/admin/companies", Building2], ["Plans & pricing", "/admin/plans", Layers], ["Categories", "/admin/categories", FolderTree], ["CMS", "/admin/cms", FileEdit], ["Activity & support", "/admin/activity", Activity], ["Settings", "/admin/settings", Settings]];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [theme, setTheme] = useTheme();
  const nav = useNavigate();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_super_admin) return <Navigate to="/app" replace />;
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b bg-navy text-white">
        <div className="mx-auto flex h-14 max-w-7xl items-center gap-6 px-5">
          <Logo light to="/admin" /><span className="rounded bg-alert/20 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-alert">Super admin</span>
          <nav className="hidden flex-1 gap-1 overflow-x-auto md:flex">
            {LINKS.map(([l, to, Icon, end]) => <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} className={({ isActive }) => `flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-sm ${isActive ? "bg-white/10" : "text-slate-400 hover:text-white"}`}><Icon className="h-4 w-4" />{l}</NavLink>)}
          </nav>
          <div className="ml-auto flex items-center gap-2"><ThemeToggle theme={theme} setTheme={setTheme} className="border-white/20" /><button onClick={async () => { await logout(); nav("/login"); }} data-testid="admin-logout" className="rounded-md p-2 hover:bg-white/10" aria-label="Log out"><LogOut className="h-4 w-4" /></button></div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-2 md:hidden">{LINKS.map(([l, to, , end]) => <NavLink key={to} to={to} end={end} className={({ isActive }) => `whitespace-nowrap rounded-md px-3 py-1 text-xs ${isActive ? "bg-white/10" : "text-slate-400"}`}>{l}</NavLink>)}</nav>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8"><Outlet /></main>
    </div>
  );
}
